import RelatedProducts from "../RelatedProducts/RelatedProducts";

import banner from "../../assets/banner.avif";
import '../MoreRelated/MoreRelated.css';

export default function MoreRelated() {
  return (
    <>

<div className="morerelated">
      <RelatedProducts />

</div>

      
    </>
  );
}
